export default __webpack_public_path__ + "static/media/Spaces-disabled.afaf17d6.svg";